export default {"src":"/_next/static/media/aeon.c5cff2f8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};